import {createFileRoute, redirect} from "@tanstack/react-router";

// /w/$workspaceId/adgpt → start a fresh chat.
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold/adgpt/",
)({
    loader: ({params}) => {
        throw redirect({
            to: `/w/$workspaceId/adgpt/chats/$chatId`,
            params: {workspaceId: params.workspaceId, chatId: "new"},
        });
    },
});
